@layer ch-tabular-grid {
  ch-tabular-grid-rowset-empty {
    display: flex;
    grid-column-start: 1;
    grid-column-end: -1;
    margin-inline-start: calc(var(--indent) * (var(--level)));
  }
  ch-tabular-grid:has(
      > ch-tabular-grid-rowset:only-of-type
        > ch-tabular-grid-rowset-empty:only-child
    )::part(main) {
    grid-template-rows: max-content 1fr;
  }
}
